import { inject } from "@angular/core";
import { HttpHeaders, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { from, mergeMap } from "rxjs";
import { AuthService } from "@shared/services/auth/auth.service";
import { environment } from "@environments/environment";

function isApiRequest(url: string): boolean {
  return url.startsWith(environment.apiv2Url) || url.startsWith(environment.apiUrl);
}

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.headers.get("Skip-Auth") === "true") {
    const headers: HttpHeaders = request.headers.delete("Skip-Auth");
    return next(request.clone({ headers }));
  }

  if (!isApiRequest(request.url)) return next(request);

  return from(inject(AuthService).getBearerToken()).pipe(
    mergeMap((token: string | null) => {
      const authRequest: HttpRequest<unknown> = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next(authRequest);
    }),
  );
};
